import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import * as i18n from "util/i18n";
import { actions as debinActions } from "reducers/debin";
import { actions as notificationActions } from "reducers/notification";
import { goBack } from "connected-react-router";
import Notification from "pages/_components/Notification";
import moment from "moment";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import SolicitDebinConfirmationBody from "./SolicitDebinConfirmationBody";

const SolicitDebinConfirmation = () => {
    const { solicitDebin, recipients, fetching, fetchingPreview, debinTicket, debinRequiredCredentials } = useSelector(
        (state) => state.debin,
    );
    const credentialType = debinRequiredCredentials.includes("otp") ? "otp" : "password";
    useConfirmTransaction({ solicitDebin, recipients }, debinTicket, "debinPayments/solicitDebin");
    const dispatch = useDispatch();

    const getExpirationDate = () => {
        const actualDate = moment();
        switch (solicitDebin?.validity) {
            case "24 horas":
                return actualDate.add(1, "days").format("YYYY-MM-DDThh:mm:ssZ");
            case "48 horas":
                return actualDate.add(2, "days").format("YYYY-MM-DDThh:mm:ssZ");
            case "72 horas":
                return actualDate.add(3, "days").format("YYYY-MM-DDThh:mm:ssZ");
            default:
                return actualDate;
        }
    };
    const expirationDate = getExpirationDate();

    useEffect(() => {
        dispatch(debinActions.fetchCredentialGroup());
    }, [dispatch]);

    useEffect(() => {
        const document = solicitDebin?.beneficiary?.document;
        dispatch(
            debinActions.sendDebinPreRequest({
                idAccount: solicitDebin?.debinAccount?.productId,
                expirationDate,
                concept: solicitDebin?.concept,
                recipients: [
                    {
                        recipientEmail: solicitDebin?.beneficiary?.email,
                        recipientDocumentNumber: document ? document.toString().split(" ")[1] : null,
                        cbu: solicitDebin?.beneficiary?.account
                            ? solicitDebin?.beneficiary?.account
                            : document?.toString().split(" ")[1],
                        schedule: false,
                        amount: {
                            quantity: solicitDebin?.amount,
                            currency: "0",
                        },
                        comprobante: "1",
                    },
                ],
            }),
        );
    }, []);

    useEffect(() => {
        if (!!solicitDebin?.beneficiary?.cbu && solicitDebin?.beneficiary?.cbu === solicitDebin?.debinAccount?.cbu) {
            dispatch(notificationActions.showNotification("debin.same.account.error", "error", ["debinPayments"]));
            dispatch(goBack());
        }
    }, [solicitDebin]);

    const beneficiaryDocument = solicitDebin?.beneficiary?.document;
    const requestBody = {
        ...solicitDebin,
        idAccount: solicitDebin?.debinAccount?.productId,
        expirationDate,
        concept: solicitDebin?.concept,
        cbu: solicitDebin?.beneficiary?.account,
        description: solicitDebin?.description,
        amount: {
            quantity: solicitDebin?.amount,
            currency: "ARS",
        },
        recipients: [
            {
                recipientEmail: solicitDebin?.beneficiary?.email,
                recipientDocumentNumber: beneficiaryDocument ? beneficiaryDocument.split(" ")[1] : null,
                cbu: solicitDebin?.beneficiary?.account
                    ? solicitDebin?.beneficiary?.account
                    : beneficiaryDocument?.split(" ")[1],
                schedule: false,
                amount: {
                    quantity: Number(solicitDebin?.amount),
                    currency: "0",
                },
                comprobante: "1",
            },
        ],
    };

    return (
        <>
            <Notification scopeToShow="solicitDebinConfirmation" />
            <ResponsiveHeader id="solicit.debin.title" />
            <MainContainer showLoader={fetchingPreview || fetching}>
                <h3>{i18n.get("debin.solicitSummary.confirm")} </h3>
                <div className="transaction-ticket ">
                    <div className="ticket">
                        <div className="ticket__wrapper">
                            <div className="ticket__header" />
                            <SolicitDebinConfirmationBody
                                solicitDebin={solicitDebin}
                                recipients={recipients}
                                expiryDate={expirationDate}
                            />
                            <div className="ticket__footer no-info" />
                        </div>
                    </div>
                </div>

                <GeneralCredentialForm
                    transactionData={requestBody}
                    type={credentialType}
                    action={debinActions.sendDebinRequest}
                    idActivity="debin.create.send"
                    hideIndications
                />
            </MainContainer>
        </>
    );
};

export default SolicitDebinConfirmation;
